import { useEffect, useRef } from 'react';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { ButtonTonal } from '@snack-uikit/button';
import { FieldStepper } from '@snack-uikit/fields';
import { IconPredefined } from '@snack-uikit/icon-predefined';
import { Tooltip } from '@snack-uikit/tooltip';
import { TruncateString } from '@snack-uikit/truncate-string';
import { Typography } from '@snack-uikit/typography';
import { useCalculatorContext, useProductContext } from '../../contexts';
import { CALCULATOR_TYPE } from '../../types';
import { getValue, parseKeyToDataTest, setValue } from '../../utils';
import { HeaderContainer } from '../HeaderContainer';
import { PriceCount } from './components';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProductPageHeadline(_ref) {
  var product = _ref.product;
  var icon = product.icon,
    label = product.label,
    enableChangeProductQuantity = product.enableChangeProductQuantity,
    productQuantityValues = product.productQuantityValues,
    freeTier = product.freeTier,
    disabledProductQuantity = product.disabledProductQuantity;
  var _ref2 = productQuantityValues !== null && productQuantityValues !== void 0 ? productQuantityValues : {},
    _ref2$min = _ref2.min,
    minProductQuantity = _ref2$min === void 0 ? 1 : _ref2$min,
    _ref2$max = _ref2.max,
    maxProductQuantity = _ref2$max === void 0 ? 99 : _ref2$max;
  var _useProductContext = useProductContext(),
    valueProp = _useProductContext.value,
    onChangeProp = _useProductContext.onChange,
    price = _useProductContext.price;
  var value = getValue(valueProp, 'productQuantity');
  var onChange = function onChange(newValue) {
    setValue(valueProp, 'productQuantity', newValue);
    onChangeProp(valueProp);
  };
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType,
    pricePeriod = _useCalculatorContext.pricePeriod,
    calculatorType = _useCalculatorContext.calculatorType,
    onConnectClick = _useCalculatorContext.actions.onConnectClick,
    selectedProduct = _useCalculatorContext.selectedProduct;
  var isPartners = calculatorType === CALCULATOR_TYPE.Partners;
  var isProductType = calculatorType === CALCULATOR_TYPE.Product;
  var isMobile = layoutType !== LAYOUT_TYPE.Desktop && layoutType !== LAYOUT_TYPE.DesktopSmall;
  var hasCounter = enableChangeProductQuantity || freeTier;
  var TitleComponent = isMobile ? Typography.SansTitleL : Typography.SansHeadlineS;
  var headerRef = useRef(null);
  useEffect(function () {
    if (headerRef.current && isMobile && !isProductType) {
      headerRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [selectedProduct, isMobile, isProductType]);
  function ConnectButton() {
    var dataTestAttribute = parseKeyToDataTest('product', 'connect-button');
    return !isPartners && product.enableConnectToConsole ? /*#__PURE__*/_jsx(Tooltip, {
      hoverDelayOpen: 600,
      tip: "\u0412\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u0432 \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438",
      children: /*#__PURE__*/_jsx(ButtonTonal, {
        fullWidth: isMobile,
        label: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
        size: "m",
        onClick: function onClick() {
          return onConnectClick === null || onConnectClick === void 0 ? void 0 : onConnectClick(product.id, valueProp);
        },
        "data-test-id": dataTestAttribute
      })
    }) : null;
  }
  return /*#__PURE__*/_jsxs(HeaderContainer, {
    ref: headerRef,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.left,
      children: [/*#__PURE__*/_jsx(IconPredefined, {
        icon: icon,
        size: isMobile ? 's' : 'm',
        decor: false,
        appearance: "primary",
        "data-test-id": parseKeyToDataTest('product', 'icon')
      }), /*#__PURE__*/_jsx(TitleComponent, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          "data-test-id": parseKeyToDataTest('product', 'title'),
          variant: "end",
          text: label,
          maxLines: 2
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.right,
      "data-mobile": isMobile || undefined,
      children: [/*#__PURE__*/_jsx(PriceCount, {
        price: price,
        pricePeriod: pricePeriod,
        freeTier: freeTier,
        mobile: isMobile,
        partners: isPartners,
        hasCounter: hasCounter
      }), hasCounter && /*#__PURE__*/_jsx("div", {
        className: styles.counter,
        "data-mobile": isMobile || undefined,
        "data-test-id": parseKeyToDataTest('product', 'counter'),
        children: /*#__PURE__*/_jsx(FieldStepper, {
          size: "m",
          step: 1,
          min: minProductQuantity,
          max: maxProductQuantity,
          value: value,
          onChange: onChange,
          disabled: freeTier || disabledProductQuantity,
          allowMoreThanLimits: false
        })
      }), !isMobile && /*#__PURE__*/_jsx(ConnectButton, {})]
    }), isMobile && /*#__PURE__*/_jsx(ConnectButton, {})]
  });
}